module.exports = __webpack_public_path__ + "img/41.1618aca.jpg";